import TabPage from "./../../../factories/tab-page";
import GenericListTab from "./../../../factories/generic-list-tab";
import GenericListSearchTab from "./../../../factories/generic-list-search-tab";
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialog from "./../../../factories/bao-dialog";
class ResourceTab extends GenericListSearchTab {
    Type: KnockoutObservable<number> = ko.observable<number>();
    Key: KnockoutObservable<string> = ko.observable<string>();
    Parent: any;
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage, parent);
        this.Parent = parent;
    }
    SearchType() {
        return "Checkware-Resource"; //SearchType
    }
    CustomFilter() {
        return [
            {
                Key: "SessionTabId",
                Value: this.TabPage.SessionTabId
            }
        ];
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        //Dummy, wird im Dialog überschrieben
        return null;
    }
    SaveSearchItem(searchItem): JQueryPromise<boolean> {
        //searchItem.PrimaryKeyValue = searchItem.ResourceId;
        searchItem.ChecklistId = this.Parent.ChecklistId;
        return super.SaveSearchItem.call(this, searchItem);
    }
    ;
}
export default ResourceTab;